import { getRect } from '@/utils/api';
import { convertPX } from '@/utils/echarts';

export const useFlowNavSwiper = () => {
	const calcSwiperRectWithShadowNodes = ({ menus = [], shadowNodeClassName }) => {
		const nodes = document.querySelectorAll(shadowNodeClassName);
		if (!nodes.length) return [];

		const widthList = Array.from(nodes).map(node => node.offsetWidth);
		const additionWidth = menus.map((v, idx) => {
			v.width = widthList[idx];
			return v;
		});

		return additionWidth;
	};

	const splitStringsIntoChunksWithPadding = ({ menus = [], wrapperNodeClassName, menuItemMargin }) => {
		if (!menus.length) return [];

		const wrapperNode = document.querySelector(wrapperNodeClassName);
		const rect = getRect(wrapperNode);
		const maxChunkWidth = rect?.width || 0; // 菜单容器宽度
		const menuMargin = convertPX(menuItemMargin); // 每个菜单的间距
		const result = [[]]; // 初始化一个二维数组，第一个子数组用于存放字符串

		let currentChunkWidth = 0; // 当前子数组的宽度

		for (const value of menus) {
			const { width } = value;
			const singleMenuW = width;
			if (currentChunkWidth + singleMenuW <= maxChunkWidth) {
				// 如果当前子数组宽度加上字符串宽度不超过最大宽度，添加到当前子数组
				result[result.length - 1].push({ ...value });
				currentChunkWidth = currentChunkWidth + singleMenuW + menuMargin;
			} else {	
				// 否则，创建新的子数组并添加字符串
				result.push([{ ...value }]);
				currentChunkWidth = singleMenuW + menuMargin; // 更新当前子数组的宽度为新添加的元素的宽度
			}
		}

		return result;
	};

	return {
		calcSwiperRectWithShadowNodes,
		splitStringsIntoChunksWithPadding
	};
};
